module.exports = "/_next/static/images/7cc2052a55d59bc7b5efd94bb4d9e699-monthly-payments-lg.jpg.webp";